<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div id="main-wrapper">
        
    
    <app-left-side-bar></app-left-side-bar>
    <app-top-bar (esLaUrl)="dinero($event)"></app-top-bar>
    <app-chat [urlString]="urlString"></app-chat>
    <!-- ============================================================== -->
    <!-- Page wrapper  -->
    <!-- ============================================================== -->
    <div class="page-wrapper">
        <app-center-content></app-center-content>
    </div>
    <!-- ============================================================== -->
    <!-- End Page wrapper  -->
    <!-- ============================================================== -->
</div>
<!-- ============================================================== -->
<!-- End Main wrapper  -->
<!-- ============================================================== -->



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_pages/dashboard/dashboard.component.html